export default "__VITE_ASSET__CW4zZ0Gh__"